import { useMutation } from '@apollo/client';
import { loader } from 'graphql.macro';
import { useCurrentUser } from '../../providers/UserProvider';

const updateCompanyMutation = loader('./update_company.graphql');

const updateUserMutation = loader('src/graphql/mutations/user_update.graphql');

export const useCompanyMutations = () => {
  const { company, user } = useCurrentUser();
  const [updateUserCompany] = useMutation(updateCompanyMutation);
  const [updateUserMut] = useMutation(updateUserMutation);
  const updateCompany = async (variables) => {
    await updateUserCompany({
      variables: { companyId: company.id, ...variables },
    });
  };

  const updateUser = async (
    { id = user.id, lastWorkspaceId, frontVersion, locale },
    variables,
  ) => {
    await updateUserMut({
      variables: { id, lastWorkspaceId, frontVersion, locale, ...variables },
    });
  };

  return { updateCompany, updateUser };
};
